"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pollStatsEpic = pollStatsEpic;

var _mergeMap = require("rxjs/operators/mergeMap");

var _exhaustMap = require("rxjs/operators/exhaustMap");

var _interval = require("rxjs/observable/interval");

var _takeUntil = require("rxjs/operators/takeUntil");

var _startWith = require("rxjs/operators/startWith");

var _of = require("rxjs/observable/of");

var _actions = require("./actions");

var POLL_INTERVAL_MS = 8000;

function pollStatsEpic(action$) {
  return action$.ofType(_actions.EcommerceV2ActionTypes.START_STATS_POLLING).pipe((0, _mergeMap.mergeMap)(function (startAction) {
    return (0, _interval.interval)(POLL_INTERVAL_MS).pipe((0, _startWith.startWith)(0), (0, _exhaustMap.exhaustMap)(function () {
      return (0, _of.of)((0, _actions.loadStats)(startAction.payload));
    }), (0, _takeUntil.takeUntil)(action$.ofType(_actions.EcommerceV2ActionTypes.STOP_STATS_POLLING)));
  }));
}